/* eslint-disable import/no-mutable-exports */
/* eslint-disable prefer-destructuring */

let colors = '';

// eslint-disable-next-line
let mode = process.env.NODE_ENV;
if (mode === 'production') {
  // eslint-disable-next-line
  colors = require('file-loader?name=themes/[name].js!@/themes/default/defaultColorPalette.scss');
} else {
  // eslint-disable-next-line
  colors = require('@/themes/default/defaultColorPalette.scss');
}

if (mode === 'production') {
  const generateData = function(path) {
    const request = new XMLHttpRequest();
    request.open('GET', path, false);
    request.send(null);
    let data = request.response;

    data = data.substring(data.indexOf('{'), data.lastIndexOf('}')).replace(/;/gi, ',').concat('}');
    return JSON.parse(data);
  };
  colors = generateData(colors);
}
if (mode === 'development') {
  // eslint-disable-next-line
  colors = require('@/themes/default/defaultColorPalette.scss');
  // eslint-disable-next-line
  // customColors = require('@/themes/custom/customColorPalette.scss');
}

// eslint-disable-next-line import/no-mutable-exports

export { colors };
